var _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiniIconLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 125,
    rx: 18,
    fill: "#F2F6F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_418_452",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 30,
    width: 80,
    height: 86
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.017 30H23V115.311H102.017V30Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_418_452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.763 91.0986L23.4573 69.6685C23.4029 69.5049 23.1961 68.9487 23.4573 68.687C23.7185 68.4252 24.1103 68.5234 24.2736 68.8505C27.1578 74.6307 32.9916 86.2891 33.2528 86.6818C33.514 87.0743 33.797 86.8454 33.9058 86.6818C40.0553 74.249 52.5826 49.0563 53.4969 47.7476C54.4111 46.4389 55.4015 47.4204 55.7825 48.0747C60.9523 58.3809 71.3573 79.0585 71.6185 79.3202C71.8798 79.5819 72.0539 79.4293 72.1083 79.3202C77.7679 67.3783 89.1525 43.3307 89.4137 42.6763C89.6749 42.022 89.5703 42.022 89.4137 42.022H85.3323C83.5038 42.022 83.9311 41.0441 84.3868 40.6333C89.0669 37.4706 98.687 30.8979 99.862 30.2436C101.038 29.5892 101.223 30.4071 101.168 30.8979C101.44 36.9507 101.986 49.1727 101.855 49.9579C101.725 50.7431 101.039 50.9395 100.679 50.5286C99.862 49.4925 98.164 47.3222 97.903 46.9296C97.642 46.537 97.468 46.7661 97.413 46.9296C90.611 60.0167 76.4836 86.7799 74.3939 89.79C72.3043 92.7999 70.401 90.9642 69.6936 89.71C64.6869 78.3679 54.5744 55.8288 54.3132 55.4363C54.0519 55.0436 53.8778 55.2727 53.8234 55.4363C47.4563 66.942 34.5915 90.1499 34.0691 90.935C33.5467 91.7203 32.9263 91.4258 32.763 91.0986Z",
    fill: "#2D3945"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniIconLogo);
export default __webpack_public_path__ + "static/media/MiniIconLogo.959b14d9315db41bc1a8766b6686b41c.svg";
export { ForwardRef as ReactComponent };